const ABBR = new Set([
  'СССР',
  'РСФСР',
  'РФ',
  'США',
  'ООН',
  'НАТО',
  'КПСС',
  'ЦК',
  'НКВД',
  'КГБ',
  'ВЧК',
  'МВД',
  'ГУЛАГ',
  'ВОВ',
  'РККА',
  'СНГ',
  'РПЦ',
  'МГУ',
  'ГДР',
  'ФРГ',
  'РСДРП',
  'ВДНХ',
  'БАМ',
  'ЕГЭ',
]);

// Служебные слова: внутри заголовка остаются строчными
const STOP_WORDS = new Set([
  'в',
  'во',
  'на',
  'над',
  'под',
  'при',
  'по',
  'за',
  'из',
  'с',
  'со',
  'к',
  'ко',
  'о',
  'об',
  'от',
  'до',
  'для',
  'у',
  'без',
  'через',
  'между',
  'и',
  'а',
  'но',
  'или',
  'же',
  'ли',
  'не',
  'ни',
]);

const isAbbr = (token) => {
  const clean = token.replace(/[^A-ZА-ЯЁ]/gi, '');
  if (!clean) return false;
  if (ABBR.has(clean)) return true;
  // римские цифры: Пётр I, XIX век
  if (/^[IVXLCDM]+$/.test(clean)) return true;
  // короткое слово без гласных — почти наверняка аббревиатура: ЦК, НКВД.
  // от 2 букв, иначе под правило попадают предлоги «в», «к», «с»
  return (
    clean.length >= 2 && clean.length <= 5 && !/[АЕЁИОУЫЭЮЯAEIOUY]/i.test(clean)
  );
};

// Заглавная у первой буквы токена: кавычки и скобки пропускаем — «Багратион»
const upperFirstLetter = (str) =>
  str.replace(/[а-яёa-z]/, (letter) => letter.toUpperCase());

// Строка целиком в верхнем регистре (иначе регистр уже поправлен в БД)
const isUpperCase = (text) => text === text.toUpperCase();

// Отчество в заголовке — значит это ФИО, даже если wiki_type проставлен неверно.
// Проверяем потокенно: \b в JS не работает с кириллицей (\w — только латиница)
const PATRONYMIC = /^[А-ЯЁ]{3,}(ОВИЧ|ЕВИЧ|ЬИЧ|ОВНА|ЕВНА|ИНИЧНА)$/i;

const hasPatronymic = (text) => {
  const tokens = text.split(/[\s,]+/).filter(Boolean);
  // одно слово — это точно не ФИО
  if (tokens.length < 2) return false;

  return tokens.some((token) =>
    PATRONYMIC.test(token.replace(/[^А-ЯЁа-яё]/g, '')),
  );
};

export const useTextCase = () => {
  // Каждое слово с заглавной — для персоналий: Энгельгардт Александр Николаевич
  const toTitleCase = (text) => {
    if (!text) return '';
    if (!isUpperCase(text)) return text;

    let isFirstWord = true;

    return text
      .split(/(\s+)/)
      .map((token) => {
        if (!token.trim()) return token;
        if (isAbbr(token)) {
          isFirstWord = false;
          return token;
        }

        const lowered = token.toLowerCase();
        const wasFirstWord = isFirstWord;
        isFirstWord = false;

        if (!wasFirstWord && STOP_WORDS.has(lowered.replace(/[^а-яё]/g, ''))) {
          return lowered;
        }

        return upperFirstLetter(lowered);
      })
      .join('');
  };

  // Заглавная только в начале предложения — для обычных статей:
  // Федералистский мятеж 1793
  const toSentenceCase = (text) => {
    if (!text) return '';
    if (!isUpperCase(text)) return text;

    const lowered = text
      .split(/(\s+)/)
      .map((token) => (isAbbr(token) ? token : token.toLowerCase()))
      .join('');

    return lowered.replace(
      /(^|[.!?:;]\s+|[«"(]\s*)([а-яёa-z])/g,
      (_, prefix, letter) => prefix + letter.toUpperCase(),
    );
  };

  // Персоналии (wiki_type === 1) — как имя, остальные записи — как предложение
  const formatWikiTitle = (item) => {
    const title = typeof item === 'string' ? item : item?.title;
    if (!title) return '';

    const isPerson = item?.wiki_type === 1 || hasPatronymic(title);

    return isPerson ? toTitleCase(title) : toSentenceCase(title);
  };

  return {
    toTitleCase,
    toSentenceCase,
    formatWikiTitle,
  };
};
